import { createAsyncThunk } from '@reduxjs/toolkit';

import { carAPI } from '@/modules/car/api';
import { CarModels } from '@/modules/car/model';
import { namespace } from '@/modules/car/namespace';

import { setModels } from '../actions';

interface CityParams {
  id: string;
  name: string;
}

const loadAllModels = createAsyncThunk(
  `${namespace}/load-all-models`,
  async (params: CityParams | undefined, { dispatch }): Promise<CarModels[]> => {
    if (!params) {
      return [];
    }

    const { id, name } = params;
    const models = await carAPI.fetchAllModels(id, name);

    dispatch(setModels({ models }));

    return models;
  },
);

export { loadAllModels };
